// @flow
import { get } from 'lodash';

const getById = (state: Object): Object => get(state, 'leagues.by_id');

export default getById;


// WEBPACK FOOTER //
// ./src/modules/selectors/league/getById.js